import React from 'react';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import NewSmsConfirmation from 'apps/auth/components/utils/NewSmsConfirmation/NewSmsConfirmation';
import SmsConfirmation from 'apps/auth/components/utils/SmsConfirmation';
import { AUTH_PROFILE_PHONE_UPDATED } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ChangePhoneNumberSmsConfirmModal = (props) => {
    const { smsConfirmation } = useExtra();
    const { custom_title } = usePageMessages();
    return (
        <ModalComponent canCloseModal modalRef={props.modalRef}>
            {smsConfirmation?.newSmsCodeEnabled ? (
                <NewSmsConfirmation
                    smsLength={6}
                    popupRef={props.popupRef}
                    headerText={custom_title}
                    headerGrayText={props.deleteAccountSmsGrayText}
                    smsConfirmation={smsConfirmation}
                    isProfileFlow={props.isProfileFlow}
                    modalRef={props.modalRef}
                    formattedNumber={props.formattedNumber}
                />
            ) : (
                <SmsConfirmation
                    headerText={custom_title}
                    smsConfirmation={smsConfirmation}
                    redirectUrl={AUTH_PROFILE_PHONE_UPDATED}
                    isProfileFlow={props.isProfileFlow}
                    modalRef={props.modalRef}
                    formattedNumber={props.formattedNumber}
                />
            )}
        </ModalComponent>
    );
};

export default ChangePhoneNumberSmsConfirmModal;
